export const TIMELINE_SKIP_SECONDS = 10;

export type PeriodDetails = {
  start: number;
  end: number;
  label: string;
  offset: number;
  sequence: number;
};
